import { HttpService } from "@rhinov/savane-js";
import { CocosConstants } from "./constants";

export class CocosServices {

    static getConfig = function(callback: CallableFunction) {
        HttpService.get(CocosConstants.resourcesBasePath + '/project.json')
            .then(
                function(response) {
                    //success
                    callback(response.data);
                },
                function() {
                    //error
                    callback(null);
                }
            );
    };
    /**
     * Retrieve list of room_features
     * FIXME url may change depending on env
     * @param callback
     */
    static getAllFunctionality = function(callback: CallableFunction) {
        HttpService.get('https://api.rhinov.fr/' + 'api/room_features/')
            .then(
                function(response) {
                    //success
                    callback(response);
                },
                function(response) {
                    //error
                    callback(response);
                }
            );
    };
    static getSortedFunctionalities = function(callback: CallableFunction) {
        // was -nb_use
        HttpService.get('https://api.rhinov.fr/' + 'api/room_features/?q.isPrimary.eq=1&sort=name&visibleHomePlanner=true')
            .then(
                function(response) {
                    //success
                    callback(response);
                },
                function(response) {
                    //error
                    callback(response);
                }
            );
    };
    static loadSecondaryFunctionality = function(mainFuncId: string, callback: CallableFunction) {
        var filter = '&q.parent_id.eq=';

        if (mainFuncId !== undefined) {
            filter += mainFuncId;
        } else {
            filter = '';
        }
        HttpService.get('https://api.rhinov.fr/' + 'api/room_features/?q.isSecondary.eq=1' + filter + '&sort=name')
            .then(
                function(response) {
                    //success
                    callback(response);
                },
                function(response) {
                    //error
                    callback(null);
                }
            );
    };
}